(function () {
  function initBc3(section) {
    var track = section.querySelector('.bc3__track');
    var slides = section.querySelectorAll('.bc3__slide');
    var dots = section.querySelectorAll('.bc3__dot');
    var prev = section.querySelector('.bc3__nav--prev');
    var next = section.querySelector('.bc3__nav--next');
    if (!track || !slides.length) return;

    function step() {
      var style = getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      return slides[0].getBoundingClientRect().width + gap;
    }

    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    // Which dot is "current". In a peek slider the last slide can never become
    // the left-most item, so when we hit the end we force the last dot active —
    // this keeps every dot reachable and the count tied to the slide count.
    function activeIndex() {
      var max = maxScroll();
      if (max <= 1) return 0;
      if (track.scrollLeft >= max - 1) return slides.length - 1;
      var s = step();
      if (!s) return 0;
      return Math.max(0, Math.min(Math.round(track.scrollLeft / s), slides.length - 1));
    }

    function update() {
      var idx = activeIndex();
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === idx);
      }
      var max = maxScroll();
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = max <= 1 || track.scrollLeft >= max - 1;
    }

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
    for (var i = 0; i < dots.length; i++) {
      (function (i) {
        dots[i].addEventListener('click', function () {
          track.scrollTo({ left: step() * i, behavior: 'smooth' });
        });
      })(i);
    }

    var raf;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    });
    window.addEventListener('resize', update);
    // scrollWidth changes as images load, so recompute then too
    window.addEventListener('load', update);
    section.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', update, { once: true });
    });

    update();
  }

  function initAll() {
    document.querySelectorAll('.bc3').forEach(initBc3);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.bc3');
    if (s) initBc3(s);
  });
})();
